import { Button } from '@tblabs/truffle';


export class DefaultButton extends Button
{
    constructor(label = "...", onClick?: (btn: DefaultButton) => void)
    {
        super(label, () => onClick?.(this));
        this.Class("uk-button uk-button-default")
            .Style('white-space: nowrap')
    }
}
